import { render, staticRenderFns } from "./Flat.vue?vue&type=template&id=165d6a05&scoped=true"
import script from "./Flat.vue?vue&type=script&lang=js"
export * from "./Flat.vue?vue&type=script&lang=js"
import style0 from "./Flat.vue?vue&type=style&index=0&id=165d6a05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165d6a05",
  null
  
)

export default component.exports